<template>
  <div>
    <b-modal :ref="id" :id="id" :title="title" scrollable size="xl" title-class="font-18" v-model="show" @hidden="resetFilters" @show="resetModal">
      <div v-if="pagination && pagination.docs">
        <slot name="header"></slot>
        <div class="row mt-3 mb-3">
          <div class="col-md-2">
            <label>{{ $t("compliance-item.compliance") }}</label>
            <select class="form-control" v-model="complianceFilter">
              <option :value="undefined">{{ $t("common.select") }}</option>
              <option v-for="c in compliances" :key="c" :value="c">{{ c }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label>{{ $t("compliance-item.name") }}</label>
            <input class="form-control" v-model="nameFilter" />
          </div>
          <div class="col-md-2">
            <label>{{ $t("compliance-item.description") }}</label>
            <input class="form-control" v-model="descriptionFilter" />
          </div>

          <div class="col-md-2">
            <label class="font-weight-bold small ">{{ $t("compliance-item-group.text") }}</label>
            <filter-select
              id="complianceGroupFilter"
              ref="complianceGroupFilter"
              :placeholder="$t('common.select')"
              :selected="complianceGroupFilter"
              @filter="onComplianceGroupSearch"
              @changed="onComplianceGroupSelect"
            >
            </filter-select>
          </div>
          <div class="col-md-2">
            <label>{{ $t("compliance-item.no") }}</label>
            <!-- <input class="form-control " v-model="noFilter" /> -->
            <filter-select id="noFilter" ref="noFilter" :placeholder="$t('compliance-item.no')" :multiple="false" @filter="onNoSearch" @changed="onNoSelect" track="name" />
          </div>
          <!-- <div class="col-md-2">
            <label>{{ $t("common.level") }}</label>
            <select class="form-control " v-model="levelFilter">
              <option :value="undefined">{{ $t("common.select") }}</option>
              <option v-for="c in [1, 2, 3]" :key="c" :value="c">{{ c }}</option>
            </select>
          </div> -->
          <div class="col-md-1">
            <button class="btn btn-secondary btn-block mt-4" @click="clearFilters">
              <i class="bx bx-trash"></i>
              <!-- {{ $t("common.clear") }} -->
            </button>
          </div>
        </div>
        <b-card
          v-for="option in pagination.docs"
          :key="option._id"
          @click="select(option)"
          header-class="bg-transparent border-primary"
          class="border border-primary m-1 mr-4"
          style="cursor: pointer"
          :class="{
            'bg-soft-secondary': isSelected(option),
            'text-white': isSelected(option),
          }"
        >
          <slot name="item" :option="option">
            <h5 class="font-size-14 text-primary text-truncate">
              {{ option.name | translate }}
            </h5>
            <p class="mr-1 text-primary text-truncate">{{ option.description | translate }}</p>
            <div>
              <span class="badge badge-soft-primary mr-1">{{ $t("compliance-item.compliance") }}: {{ option.compliance }}</span>
              <span class="badge badge-soft-secondary mr-1">{{ $t("compliance-item.no") }}: {{ option.no }}</span>
              <span class="badge badge-soft-warning mr-1">{{ $t("common.level") }}: {{ option.level }}</span>
              <span v-if="option.group" class="badge badge-soft-info">{{ option.group.name | translate }}</span>
            </div>
          </slot>
        </b-card>

        <content-loading v-if="isLoading" />
        <!-- Begin: Pagination -->

        <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
          <h5 class="text-center" id="myText">
            {{ $t("common.no-data") }}
          </h5>
        </empty>

        <div v-if="pagination" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button @click="show = false" variant="secondary" class="btn-label float-right btn-sm">
            <i class="bx bx-window-close label-icon"></i>
            {{ $t("common.close") }}
          </b-button>

          <b-button v-if="multiple" class="btn-label float-right btn-sm mr-1" variant="primary" @click="ok">
            <i class="bx bx-check-double font-size-16 align-middle label-icon"></i>
            {{ $t("common.select") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["id", "title", "store", "multiple", "requestQuery"],
  data() {
    return {
      show: false,
      nameFilter: undefined,
      complianceFilter: undefined,
      noFilter: undefined,
      levelFilter: undefined,
      descriptionFilter: undefined,
      complianceGroupFilter: undefined,
      selections: [],
      request: {
        options: { limit: 15, sort: { name: "asc" } },
        query: {},
      },
    };
  },
  computed: {
    pagination() {
      return this.$store.getters[`${this.store}/paginationForSearch`];
    },
    isLoading() {
      return this.$store.getters[`${this.store}/isLoading`];
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,

      handler() {
        this.debounceMixin(() => this.resetModal());
      },
    },

    nameFilter(n, o) {
      if (n) {
        this.request.query = {
          ...this.request.query,
          name: { value: n },
        };
      } else {
        const { name, ...rest } = this.request.query;
        this.request.query = rest;
      }
    },
    descriptionFilter(n, o) {
      if (n) {
        this.request.query = {
          ...this.request.query,
          description: { value: n },
        };
      } else {
        const { description, ...rest } = this.request.query;
        this.request.query = rest;
      }
    },
    complianceGroupFilter(n, o) {
      if (n) {
        this.request.query = {
          ...this.request.query,
          group: { value: n, isObject: true },
        };
      } else {
        const { complianceGroup, ...rest } = this.request.query;
        this.request.query = rest;
      }
    },
    complianceFilter(v) {
      this.$refs?.noFilter.reset();
      this.$refs?.complianceGroupFilter.reset();
      if (v) {
        this.request.query = {
          ...this.request.query,
          compliance: { value: v, isObject: true },
        };
      } else {
        const { compliance, ...rest } = this.request.query;
        this.request.query = rest;
      }
    },
    noFilter(v) {
      if (v) {
        this.request.query = {
          ...this.request.query,
          no: { value: v, isObject: true },
        };
      } else {
        const { no, ...rest } = this.request.query;
        this.request.query = rest;
      }
    },

    levelFilter(v) {
      if (v) {
        this.request.query = {
          ...this.request.query,
          level: { value: v, isObject: true },
        };
      } else {
        const { level, ...rest } = this.request.query;
        this.request.query = rest;
      }
    },
    requestQuery: {
      immediate: true,
      deep: true,
      handler(v) {
        if (v) {
          this.request.query = {
            ...this.request.query,
            ...this.requestQuery,
          };
        }
      },
    },
  },
  methods: {
    async onComplianceGroupSearch(value, callback) {
      const response = await this.$store.dispatch(`libraryComplianceItemGroup/paginate`, {
        options: { limit: 200, sort: { name: "asc" } },
        query: { ...(this.complianceFilter ? { compliances: { value: this.complianceFilter, isObject: true } } : {}), name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onComplianceGroupSelect(item) {
      this.complianceGroupFilter = item;
    },
    resetFilters() {
      this.nameFilter = undefined;
      this.complianceFilter = undefined;
      this.noFilter = undefined;
      this.levelFilter = undefined;
      this.descriptionFilter = undefined;
      this.complianceGroupFilter = undefined;
    },
    resetModal() {
      this.$store.dispatch(`${this.store}/paginateForSearch`, this.request);
    },
    select(option) {
      if (!this.multiple) {
        this.show = false;
        this.$emit("selected", option);
        return;
      }

      const founded = this.selections.find((i) => i._id == option._id);
      if (founded) {
        this.selections = [...this.selections.filter((i) => i._id != option._id)];
      } else {
        this.selections.push(option);
      }
    },

    isSelected(option) {
      return !!this.selections.find((i) => i._id == option._id);
    },
    ok() {
      this.show = false;
      this.$emit("selected", this.selections);
    },

    clearFilters() {
      this.nameFilter = undefined;
      this.complianceFilter = undefined;
      this.noFilter = undefined;
      this.levelFilter = undefined;
    },
    onNoSelect(value) {
      this.noFilter = value?.name?.tr;
    },

    async onNoSearch(value, callback) {
      const queryValue = { $regex: `.*${value}.*`, $options: "i" };
      const response = await this.$store.dispatch(`${this.store}/paginateForSearch`, {
        options: { limit: 200, sort: { no: "asc" } },
        query: { ...(this.complianceFilter ? { compliance: { value: this.complianceFilter, isObject: true } } : {}), no: { value: queryValue, isObject: true } },
      });

      const options = response.data?.docs.map((i) => ({ name: { tr: i.no, en: i.no, de: i.no, fr: i.no } })) ?? [];

      // Maddde numaralarını (1.1, 1.2, 1.10 vb.) doğal sıralama ile sıralıyoruz
      options.sort((a, b) => (a.name.tr || "").localeCompare(b.name.tr || "", undefined, { numeric: true, sensitivity: "base" }));

      callback(options);
    },
    async onFilterSearch(value, field, callback) {
      if (typeof field === "function") {
        callback = field;
        field = "name";
      }

      const query = {};
      query[field] = { value: value, op: "iLike" };

      const response = await this.$store.dispatch(`${this.store}/paginate`, {
        options: { limit: 20 },
        query,
      });

      callback(response.data?.docs ?? []);
    },
  },
};
</script>

<style></style>
